import React from 'react';
import { Box, Typography } from '@mui/material';

import { getComponentLabelInformation } from '../../../../store/selectors/componentLabelInformationSelector';
import { getActiveComponentSpans } from '../../../../store/selectors/getActiveComponentSpansSelector';
import { getDistanceFormatterSelector } from '../../../../store/selectors/getDistanceFormatterSelector';
import { useAppSelector } from '../../../hooks';

export function SelectedComponentRowAdditionalInformation() {
  const info = useAppSelector(getComponentLabelInformation);
  const spans = useAppSelector(getActiveComponentSpans);

  const formatDistance = useAppSelector(getDistanceFormatterSelector);

  if (info == null || spans == null) return null;

  const { quantity, numberOfPlies, priceInformation } = info;

  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',

        marginBottom: 1,

        '&>p': {
          textAlign: 'center',
          padding: 0.25,
        },
      }}
    >
      <Typography variant="body2" color="textSecondary">
        Quantity: {quantity}
      </Typography>
      <Typography variant="body2" color="textSecondary">
        Plies: {numberOfPlies}
      </Typography>
      <Typography variant="body2" color="textSecondary">
        Price: {priceInformation.priceText}
      </Typography>
      <Typography variant="body2" color="textSecondary">
        Span: {formatDistance(spans.bearingSpan)}
      </Typography>
    </Box>
  );
}
